import OrderExternalIdUpdateParams from "../../../../../../common/services/order/external-id-update/order-external-id-update-params";
import OrderDetailsChangeCargoExternalIdFormData from "../types/order-details-change-cargo-external-id-form-data";

const createChangeCargoExternalIdRequest = (
  formData: OrderDetailsChangeCargoExternalIdFormData,
  orderUuid: string,
): OrderExternalIdUpdateParams => {
  return {
    orderUuid: orderUuid,
    newExternalId: formData.cargoExternalId,
  };
};

const orderDetailsChangeCargoExternalIdFactory = {
  createChangeCargoExternalIdRequest,
};

export default orderDetailsChangeCargoExternalIdFactory;
